<div class="container-fluid cards-container">
    @let kpi = kpis()[0];
    <div class="row g-3">
        <div class="col-sm-6 col-lg-3">
            <kpi-card
                [title]="texts.numberLinkyMeters.title"
                [body]="{
                    value: kpi.numberLinkyMeters,
                    precision: texts.numberLinkyMeters.precision,
                }"
                [badge]="{
                    value: kpi.numberLinkyMetersEvolution,
                    suffix: texts.numberLinkyMeters.badgeSuffix,
                    precision: texts.numberLinkyMeters.badgePrecision,
                    style: kpi.numberLinkyMetersEvolution! > 0 ? 'success' : 'danger',
                }"
                [descriptionTitle]="texts.numberLinkyMeters.descriptionTitle"
                [descriptionContent]="texts.numberLinkyMeters.descriptionContent"
                [isLoading]="!kpi.organizationId"
                [error]="checkKpiErrors(kpi, 'numberLinkyMeters')"
                cardClass="h-100">
            </kpi-card>
        </div>
        <div class="col-sm-6 col-lg-3">
            <kpi-card
                [title]="texts.deploymentRate.title"
                [body]="{
                    value: kpi.deploymentRate,
                    precision: texts.deploymentRate.precision,
                    suffix: texts.deploymentRate.suffix,
                }"
                [badge]="{
                    value: kpi.deploymentRateEvolution,
                    suffix: texts.deploymentRate.badgeSuffix,
                    precision: texts.deploymentRate.badgePrecision,
                    style: kpi.deploymentRateEvolution! > 0 ? 'success' : 'danger',
                }"
                [isLoading]="!kpi.organizationId"
                [error]="checkKpiErrors(kpi, 'deploymentRate')"
                cardClass="h-100">
            </kpi-card>
        </div>
        <div class="col-sm-6 col-lg-3">
            <kpi-card
                [title]="texts.communicatingMetersRate.title"
                [body]="{
                    value: kpi.communicatingMetersRate,
                    precision: texts.communicatingMetersRate.precision,
                    suffix: texts.communicatingMetersRate.suffix,
                }"
                [badge]="{
                    value: kpi.communicatingMetersRateEvolution,
                    suffix: texts.communicatingMetersRate.badgeSuffix,
                    precision: texts.communicatingMetersRate.badgePrecision,
                    style: kpi.communicatingMetersRateEvolution! > 0 ? 'success' : 'danger',
                }"
                [descriptionTitle]="texts.communicatingMetersRate.descriptionTitle"
                [descriptionContent]="texts.communicatingMetersRate.descriptionContent"
                [isLoading]="!kpi.organizationId"
                [error]="checkKpiErrors(kpi, 'communicatingMetersRate')"
                cardClass="h-100">
            </kpi-card>
        </div>
    </div>

    <chart-card
        id="metersTypologyChart"
        [title]="texts.metersTypologyChart.title"
        [error]="metersTypologyChartError"
        [isLoading]="!metersTypologyChartData()[0].organizationId"
        [series]="metersTypologyChartSeries"
        [dataLabels]="metersTypologyDataLabels"
        [stacked]="true"
        [xaxisCategories]="metersTypologyXcategories"
        [yaxis]="metersTypologyYaxis"
        [precision]="texts.metersTypologyChart.precision"
        [customTooltip]="metersTypologyCustomTooltip"
        [xaxisTitle]="texts.metersTypologyChart.xaxisTitle"
        class="h-100">
    </chart-card>

    <chart-card
        id="linkyDeploymentRateComparisonChart"
        [title]="texts.linkyDeploymentRateComparisonChart.title"
        [descriptionTitle]="texts.linkyDeploymentRateComparisonChart.descriptionTitle"
        [descriptionContent]="texts.linkyDeploymentRateComparisonChart.descriptionContent"
        [error]="linkyDeploymentRateComparisonChartError"
        [isLoading]="!linkyDeploymentRateComparisonChartDataSignal()[0].organizationId"
        [type]="'rangeBar'"
        [dataLabels]="rateComparisonDataLabels"
        [yaxis]="linkyDeploymentRateChartYaxis"
        [series]="linkyDeploymentRateComparisonChartSeries"
        [plotOptions]="rateComparisonPlotOptions"
        [customTooltip]="rateComparisonCustomTooltip"
        cardClass="h-100"></chart-card>

    <geo-map-card
        [title]="texts.linkyMeterDeploymentRateMap.title"
        [descriptionContent]="texts.linkyMeterDeploymentRateMap.descriptionContent"
        [descriptionTitle]="texts.linkyMeterDeploymentRateMap.descriptionTitle"
        [geometries]="geometries()"
        [isLoading]="!geometries()[0].organizationId"
        [error]="!!geometries()[0].error"
        [getStyle]="getMapStyle"
        [legendConfig]="legendConfig"
        [mapId]="'lvUndergroundingRateMap'"
        [getTooltip]="getTooltip"></geo-map-card>
</div>
